import React, { Component } from "react";
import AUX from "../../hoc/Aux_";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import { withRouter } from "react-router";
import LoaderSPO from "../../components/UI/Loader/LoaderSPO1";
import { Link } from "react-router-dom";
import MapDialog from "../Map/MapDialog";
import MapLeaflet from "../Map/MapLeaflet";
import { mapData, searchrdfquery } from "../../api/kugi";
import { fetchLayer } from "../../api/cms";
import Axios from "axios";

let cancelToken;

class PencarianSPO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listSublayer: [],
      loadingMap: true,
      wmsSubLayer: [],
    };
  }

  componentWillMount = async () => {
    await fetchLayer().then((res) => {
      this.setState({ listSublayer: res.data });
    });
    this.handleListMap();
  };

  handleKoor = (item) => {
    try {
      let temp = item.split("^", 1);
      return temp;
    } catch {
      return item;
    }
  };

  handleId = async (subjek) => {
    console.log(subjek);
    if (cancelToken) {
      cancelToken.cancel("Request cancelled");
    }
    cancelToken = Axios.CancelToken.source();
    let objekId = null;
    await searchrdfquery("memilikiFCODE", "", `@${subjek}`, cancelToken.token)
      .then((res) => {
        res.data.map((item) => {
          if (item.objek.length > 2) {
            objekId = item.objekId;
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
    return objekId;
  };

  handleObjectSearch = async (subjek) => {
    this.props.restate(subjek)
    this.setState({listSublayer: [], loadingMap: true, wmsSubLayer: []})
    let item = await this.handleId(subjek);
    this.props.searchObject(item, subjek);
    await fetchLayer().then((res) => {
      this.setState({ listSublayer: res.data });
    });
    this.handleListMap();
  };

  handlePrediket = (prediket) => {
    let temp = this.props.predikatValue.indexOf(prediket);
    return this.props.predikatLabel[temp];
  };

  handleListMap = async () => {
    this.setState({ loadingMap: true, wmsSubLayer: [] });
    await Promise.all(
      this.state.listSublayer.map(async (item) => {
        await mapData(item, this.props.objekId)
          .then((res) => {
            if (res.data.features.length !== 0) {
              this.setState({
                wmsSubLayer: [
                  ...this.state.wmsSubLayer,
                  { ...res.data, host: item.host, layer: item.layer },
                ],
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
    ).then(() => {
      this.setState({ loadingMap: false });
      console.log(this.state.wmsSubLayer);
    });
  };

  // handleClick = (item) => {
  //   this.props.dialog(item)
  //   this.handleListMap()
  // }

  render() {
    return (
      <AUX>
        {this.props.open ? (
          <React.Fragment>
            <br />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <h4>{this.props.subjek}</h4>
              </Grid>
              {/* <Grid item xs={3}>
                <Button>
                  <Link to={`/mapdetail?id=${this.props.objekId}`}>
                    <a>Go to Map</a>
                  </Link>
                </Button>
              </Grid> */}
            </Grid>
            <br />
            <Grid container spacing={3} style={{ marginBottom: 20 }}>
              {this.props.objekId === null ? null : (
                <React.Fragment>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#eaecf0",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    <b>Map</b>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#FFF",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    <b>Gambar Map</b>
                  </Grid>
                  {this.state.wmsSubLayer.map((item, index) => (
                    <React.Fragment>
                      <Grid
                        item
                        xs={6}
                        style={{
                          backgroundColor: "#eaecf0",
                          border: "1px solid #c8ccd1",
                        }}
                      >
                        {item.features[0].nama_layer}
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{
                          backgroundColor: "#FFF",
                          border: "1px solid #c8ccd1",
                          // position: "relative"
                        }}
                      >
                        <MapLeaflet
                        data={item}
                        sublayer={item.features[0].sublayer}
                        id={this.props.objekId}
                        />
                        {/* <MapDialog
                          id={this.props.objekId}
                          layer={item.layer}
                          host={item.host}
                          sublayer={item.features[0].sublayer}
                          filter={item.features[0].filter}
                          data={item.features[0].data}
                          json={item}
                          type={item.features[0].geometry.type}
                        /> */}
                      </Grid>
                    </React.Fragment>
                  ))}
                  {this.state.loadingMap ? (
                    <React.Fragment>
                      <Grid
                        item
                        xs={6}
                        style={{
                          backgroundColor: "#eaecf0",
                          border: "1px solid #c8ccd1",
                        }}
                      >
                        <LoaderSPO />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{
                          backgroundColor: "#FFF",
                          border: "1px solid #c8ccd1",
                        }}
                      >
                        <LoaderSPO />
                      </Grid>
                    </React.Fragment>
                  ) : null}
                  {!this.state.loadingMap &&
                  this.state.wmsSubLayer.length === 0 ? (
                    <React.Fragment>
                      <Grid
                        item
                        xs={6}
                        style={{
                          backgroundColor: "#eaecf0",
                          border: "1px solid #c8ccd1",
                        }}
                      >
                        Tidak ada map
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{
                          backgroundColor: "#FFF",
                          border: "1px solid #c8ccd1",
                        }}
                      >
                        Tidak ada gambar map
                      </Grid>
                    </React.Fragment>
                  ) : null}
                </React.Fragment>
              )}
              <Grid
                item
                xs={6}
                style={{
                  backgroundColor: "#eaecf0",
                  border: "1px solid #c8ccd1",
                }}
              >
                <b>Predikat</b>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  backgroundColor: "#FFF",
                  border: "1px solid #c8ccd1",
                }}
              >
                <b>Objek</b>
              </Grid>
              {this.props.dataSPO.map((item) => (
                <React.Fragment>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#eaecf0",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    <a
                      style={{
                        cursor: "pointer",
                        color: "blue",
                      }}
                      onClick={() =>
                        this.props.search(
                          item[0].prediket,
                          this.handlePrediket(item[0].prediket),
                          "predikat"
                        )
                      }
                    >
                      {this.handlePrediket(item[0].prediket)}
                    </a>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#FFF",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    {item.length > 1 ? (
                      <>
                        {item.map((result) => (
                          <li>
                            {result.objek.includes("http://") ? (
                              <Link
                                to={{ pathname: result.objek }}
                                target="_blank"
                              >
                                <a>{result.objek}</a>
                              </Link>
                            ) : (
                              <a
                                style={{
                                  cursor: "pointer",
                                  color: "blue",
                                }}
                                onClick={
                                  () =>
                                    // {this.props.objekId ? this.props.searchObject(result.objek) : this.props.searchSPO(result)}
                                    this.handleObjectSearch(result.objek)
                                  // this.props.search(
                                  //   result.objek,
                                  //   result.objek,
                                  //   "objek"
                                  // )
                                }
                              >
                                {result.objek}
                              </a>
                            )}
                          </li>
                        ))}
                      </>
                    ) : item[0].objek.includes("http://") ? (
                      item[0].prediket === "memilikiKOORDY" ||
                      item[0].prediket === "memilikiKOORDX" ? (
                        <p>
                          <a
                            style={{
                              cursor: "pointer",
                              color: "blue",
                            }}
                            onClick={
                              () =>
                                // {this.props.objekId ? this.props.searchObject(item[0].objek) : this.props.searchSPO(item[0])}
                                this.handleObjectSearch(item[0].objek)
                              // this.props.search(
                              //   item[0].objek,
                              //   item[0].objek,
                              //   "objek"
                              // )
                            }
                          >
                            {this.handleKoor(item[0].objek)}
                            {/* {item[0].objek} */}
                          </a>
                        </p>
                      ) : (
                        <Link to={{ pathname: item[0].objek }} target="_blank">
                          <a>{item[0].objek}</a>
                        </Link>
                      )
                    ) : (
                      <p>
                        <a
                          style={{
                            cursor: "pointer",
                            color: "blue",
                          }}
                          onClick={
                            () =>
                              // {this.props.objekId ? this.props.searchObject(item[0].objek) : this.props.searchSPO(item[0])}
                              this.handleObjectSearch(item[0].objek)
                            // this.props.search(
                            //   item[0].objek,
                            //   item[0].objek,
                            //   "objek"
                            // )
                          }
                        >
                          {this.handleKoor(item[0].objek)}
                          {/* {item[0].objek} */}
                        </a>
                      </p>
                    )}
                  </Grid>
                </React.Fragment>
              ))}
              {this.props.loading ? (
                <React.Fragment>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#eaecf0",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    <LoaderSPO />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#FFF",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    <LoaderSPO />
                  </Grid>
                </React.Fragment>
              ) : null}
              {!this.props.loading && this.props.dataSPO.length === 0 ? (
                <React.Fragment>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#eaecf0",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    Tidak ada data
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: "#FFF",
                      border: "1px solid #c8ccd1",
                    }}
                  >
                    Tidak ada data
                  </Grid>
                </React.Fragment>
              ) : null}
            </Grid>
          </React.Fragment>
        ) : null}
      </AUX>
    );
  }
}

export default withRouter(PencarianSPO);
